import { createContext, useCallback, useContext, useState } from "react";
import { analytics } from "@/lib/analytics";

const DonationContext = createContext({
  open: false,
  openModal: () => {},
  closeModal: () => {},
});

export function DonationProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openModal = useCallback((source = "cta") => {
    // Fire tracking (safe no-op when GA/Pixel not configured)
    const src = typeof source === "string" ? source : "cta";
    analytics.donateClick(src);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <DonationContext.Provider value={{ open, openModal, closeModal }}>
      {children}
    </DonationContext.Provider>
  );
}

export function useDonation() {
  return useContext(DonationContext);
}
